// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck

export const logError = (from: string, error: unknown) => {
    console.log(`${from} error:`, error)
    if (typeof newrelic == 'object') {
        newrelic.addPageAction('visa_error', {
            from,
            error
        })
    }
}
